export default __webpack_public_path__ + "static/media/img2.cc64e7ef.jpg";